module.exports = __webpack_public_path__ + "images/preview@1x.png?d0ddb85a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/preview@1x.png
// module id = 680
// module chunks = 7